import FeatureCard from "../components/features/FeatureCard";
import StepChip from "../components/features/StepChip";
import {
  RESTAURANT_REQUEST_FEATURES,
  RESTAURANT_REQUEST_SERVICES_FEATURES,
  RESTAURANT_REQUEST_STEPS,
} from "../configs";
import RestaurantRequestForm from "../forms/RestaurantRequest.form";

const RestaurantRequest = () => {
  const renderedFeatures = RESTAURANT_REQUEST_FEATURES.map((feature, index) => (
    <FeatureCard
      key={index}
      text={feature.text}
      image={feature.image}
    />
  ));

  const renderedServicesFeatures = RESTAURANT_REQUEST_SERVICES_FEATURES.map(
    (feature, index) => (
      <FeatureCard
        key={index}
        text={feature.text}
        image={feature.image}
      />
    )
  );

  const renderedSteps = RESTAURANT_REQUEST_STEPS.map((step, index) => (
    <StepChip
      key={index}
      index={index + 1}
      text={step}
    />
  ));

  const anchorClasses =
    "bg-primary text-white font-semibold p-3 rounded w-min whitespace-nowrap cursor-pointer";

  return (
    <div className="w-full flex flex-col items-center justify-center">
      <div className="w-full flex items-center py-8 lg:p-8">
        <div className="w-full lg:w-3/5 items-center lg:items-start text-center lg:text-start flex flex-col gap-4">
          <h1 className="text-3xl lg:text-5xl font-bold">
            Devenez <span className="text-primary">Restaurant Partenaire</span>
          </h1>
          <a
            className={anchorClasses}
            href="#restaurant-request-form"
          >
            Inscription rapide
          </a>
        </div>
        <div className="w-2/5 hidden lg:flex justify-between">
          <img
            src="/assets/images/restaurant-request.png"
            className="w-3/5 mx-auto object-fit ml-auto"
          />
        </div>
      </div>
      <div className="w-full my-20 px-12 md:mt-32 grid grid-cols-1 lg:grid-cols-4 items-center gap-3">
        {renderedFeatures}
      </div>
      <div className="w-full bg-gray-100/50 py-12 lg:py-20 px-8 flex justify-between items-center">
        <div className="flex flex-col gap-4">
          <h2 className="font-bold text-3xl"> Le service BipBip </h2>
          <ul className="list-disc marker:text-primary text-gray-600 ml-6 space-y-3">
            <li>
              Service d’assistance : <br />
              De 9h30 à 22h30 du lundi au vendredi <br />
              De 10h30 à 22h30 le samedi et dimanche
            </li>
            <li> Nos partenaires coursiers à votre service </li>
            <li> Jusqu’à 25km autour de la ville choisie </li>
            <li> Selon vos horaires du lundi au dimanche </li>
            <li> Gérez votre temps lors d’une prise de commande </li>
          </ul>
          <a
            className={anchorClasses}
            href="#restaurant-request-form"
          >
            Démarrer maintenant
          </a>
        </div>
        <img
          src="/assets/images/breakfast.png"
          className="w-[40%] object-fit hidden lg:block"
          alt="brakfast"
        />
      </div>
      <div className="w-full my-20 flex items-center">
        <div className="w-1/2 flex hidden lg:block">
          <img
            src="/assets/images/table-meal.png"
            alt="table meal"
            className="w-[70%] object-fit mx-auto"
          />
        </div>
        <div className="w-full lg:w-1/2 ml-6 flex flex-col gap-5">
          <h2 className="font-bold text-3xl"> Horaires de livraison </h2>
          <div className="flex gap-3">
            <div className="p-5 text-lg bg-gray-100/50 rounded-tl-3xl rounded-br-3xl text-gray-500">
              10h30 - 14h30
            </div>
            <div className="p-5 text-lg bg-gray-100/50 rounded-tl-3xl rounded-br-3xl text-gray-500">
              17h30 - 22h30
            </div>
          </div>
          <div>
            Du <b> Lundi </b> au <b> Dimanche </b>
          </div>
        </div>
      </div>
      <div className="w-full bg-gray-100/50 py-20 px-8 flex flex-col justify-between items-center text-center gap-6">
        <h2 className="font-bold text-3xl mx-auto mb-12">
          Comment devenir <br />
          partenaire ?
        </h2>
        <div className="grid gird-cols-1 lg:grid-cols-4 gap-y-12 mb-8">
          {renderedSteps}
        </div>
        <a
          className={anchorClasses}
          href="#restaurant-request-form"
        >
          Être rappelé par un conseiller
        </a>
      </div>
      <h2 className="font-bold text-3xl mt-20"> Services proposés </h2>
      <div className="w-full my-20 grid gird-cols-1 lg:grid-cols-4 px-6 items-center gap-3 gap-y-12">
        {renderedServicesFeatures}
      </div>
      <div className="w-full bg-primary px-8 py-12 lg:py-32 my-12 flex flex-col lg:flex-row items-center text-white gap-6">
        <div className="w-full lg:w-1/2 flex flex-col gap-2 font-bold">
          <h2 className="text-3xl">Qu&apos;attendez-vous ? </h2>
          <p className="text-lg">
            Profitez de nos services et augmentez votre chiffre d’affaire dès
            aujourd&apos;hui.
          </p>
        </div>
        <div className="w-1/2 flex hover:opacity-50 cursor-pointer">
          <a
            className="px-6 py-3 border-2 border-white rounded mx-auto"
            href="#restaurant-request-form"
          >
            C&apos;est parti
          </a>
        </div>
      </div>
      <div className="w-full p-4 lg:my-12 block lg:flex justify-center lg:gap-12">
        <div
          id="restaurant-request-form"
          className="flex flex-col w-full lg:w-3/5"
        >
          <h2 className="text-3xl font-bold mb-8"> Devenir partenaire </h2>
          <RestaurantRequestForm />
        </div>
        <div className="w-2/5 flex justify-center">
          <img
            className="w-4/5 mx-auto object-contain p-2 hidden lg:block"
            src="/assets/images/restaurant-request.png"
            alt="rider"
          />
        </div>
      </div>
    </div>
  );
};

export default RestaurantRequest;
